<template>
    <VerticalSlideTransition
        :show="show"
        :duration="duration"
        :keepAlive="true"
    >
        <HorizontalSlideTransition
            :show="show"
            :duration="duration"
            :keepAlive="true"
        >
            <slot></slot>
        </HorizontalSlideTransition>
    </VerticalSlideTransition>
</template>

<script>
import VerticalSlideTransition from "@/Components/Transitions/VerticalSlideTransition.vue";
import HorizontalSlideTransition from "@/Components/Transitions/HorizontalSlideTransition.vue";

export default {
    components: {
        VerticalSlideTransition,
        HorizontalSlideTransition,
    },
    name: "BoxTransition",

    props: {
        show: {
            type: Boolean,
            default: false,
        },
        duration: {
            type: Number,
            default: 400,
        },
    },
};
</script>
